import React from 'react';
import { useNavigate } from 'react-router-dom';

function PlaylistCard({ playlist, onDelete }) {
  const navigate = useNavigate();

  const getPlaylistType = () => {
    if (playlist.username && playlist.password) return 'xtream';
    return 'm3u';
  };

  const type = getPlaylistType();

  return (
    <div className="playlist-card">
      <div className="playlist-card-header">
        <div className="playlist-card-title">
          <h3>{playlist.name}</h3>
          {playlist.hasPin && (
            <div className="pin-indicator" title="PIN Protected">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
          )}
        </div>
      </div>

      <div className="playlist-card-body">
        <span className={`playlist-type ${type}`}>
          {type === 'xtream' ? 'Xtream' : 'M3U'}
        </span>
        {playlist.category && (
          <span className="playlist-category">{playlist.category}</span>
        )}
      </div>

      <div className="playlist-card-actions">
        <button
          className="btn btn-secondary"
          onClick={() => navigate(`/edit/${playlist.id}`)}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
          Edit
        </button>
        <button
          className="btn btn-danger"
          onClick={() => onDelete(playlist)}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          </svg>
          Delete
        </button>
      </div>
    </div>
  );
}

export default PlaylistCard;
